import React, { FunctionComponent, useState } from 'react';

import PopupDialog from '../../shared/PopupDialog';

interface IPublishChangesDialogProps {
  open: boolean;
  close: () => void;
  onConfirm: (comment: string) => void;
  lockedGroups?: Array<string>;
}

const PublishChangesDialog: FunctionComponent<IPublishChangesDialogProps> = ({
  open,
  close,
  onConfirm,
  lockedGroups,
}) => {
  const [comment, setComment] = useState('');

  return (
    <PopupDialog
      open={open}
      close={close}
      title="Publish Changes"
      primaryButtons={[
        {
          id: 'confirmButton',
          label: 'Confirm',
          onClick: () => onConfirm(comment),
        },
      ]}
    >
      {lockedGroups && lockedGroups.length > 0 ? (
        <p style={{ margin: '0px' }}>
          The following groups have been locked. If you proceed, a submission
          will not be made to these groups:{' '}
          <strong>{lockedGroups.join(', ')}</strong>. Please confirm that you
          would like to proceed
        </p>
      ) : (
        'Please confirm you would like to save your edits as the new active version of the scenario.'
      )}
      <textarea
        placeholder="Add a comment (optional)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        style={{
          width: '100%',
          marginTop: '1rem',
          padding: '0.75rem',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '1rem',
          lineHeight: '1.5',
          resize: 'vertical',
          boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
          transition: 'border-color 0.3s, box-shadow 0.3s',
        }}
        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 1px 3px rgba(0, 0, 0, 0.1)')}
      />
    </PopupDialog>
  );
};

export default PublishChangesDialog;
